import { lazy, Suspense } from 'react';
import { Route, Switch } from 'wouter';

import DataProvider from './DataProvider';
import Loader from './Loader';
import NotFound from './NotFound';

const LazyViewer = lazy(async () => import('./Viewer.js'));
const LazyDiffImageService = lazy(
  async () => import('./diff-image/DiffImageService.js'),
);
const LazySaxsCurvesService = lazy(
  async () => import('./saxs-curves/SaxsCurvesService.js'),
);
const LazySaxsHplcService = lazy(
  async () => import('./saxs-hplc/SaxsHplcService.js'),
);

function App() {
  return (
    <Suspense fallback={<Loader message="Signing in to ICAT..." />}>
      <DataProvider>
        <Switch>
          <Route path="/viewer">
            <Suspense fallback={<Loader message="Loading viewer..." />}>
              <LazyViewer />
            </Suspense>
          </Route>
          <Route path="/diffraction-image">
            <Suspense fallback={<Loader message="Loading visualization..." />}>
              <LazyDiffImageService />
            </Suspense>
          </Route>
          <Route path="/saxs-curves">
            <Suspense fallback={<Loader message="Loading visualization..." />}>
              <LazySaxsCurvesService />
            </Suspense>
          </Route>
          <Route path="/saxs-hplc">
            <Suspense fallback={<Loader message="Loading visualization..." />}>
              <LazySaxsHplcService />
            </Suspense>
          </Route>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </DataProvider>
    </Suspense>
  );
}

export default App;
